<template>
  <div class="sidebar-pinned">
    <Navbar />

    <main class="admin-main">

      <!-- ── Page Header ── -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center text-white" style="padding: 32px 0;">
            <div class="header-icon-wrap mr-3">
              <i class="fe fe-user" style="font-size: 22px;"></i>
            </div>
            <div>
              <h4 class="mb-0 font-weight-bold">Hello, {{ auth_user.firstname }} {{ auth_user.lastname }}</h4>
              <small style="opacity: 0.8;">Insurance staff dashboard</small>
            </div>
            <div class="ml-auto"><TodayTasks /></div>
          </div>
        </div>
      </div>

      <section style="margin-top: -32px;">
        <div class="container pb-5">

          <!-- ── Stat Cards ── -->
          <div class="row mb-4">
            <div class="col-lg-4 col-md-4 mb-3">
              <div class="card shadow stat-card h-100" style="border-left: 4px solid #2563eb;">
                <div class="card-body d-flex align-items-center py-3 px-4">
                  <div class="mr-3"
                    style="width: 44px; height: 44px; background: #eef2ff; border-radius: 10px; display: flex; align-items: center; justify-content: center; flex-shrink: 0;">
                    <i class="fe fe-home" style="font-size: 20px; color: #2563eb;"></i>
                  </div>
                  <div>
                    <p class="mb-0 text-muted"
                      style="font-size: 0.75rem; text-transform: uppercase; letter-spacing: .05em;">Health Facilities</p>
                    <h3 class="mb-0 font-weight-bold" style="line-height: 1.2;">
                      {{ providers.length || '—' }}
                    </h3>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-4 col-md-4 mb-3">
              <router-link to="/manage-clients" class="text-decoration-none">
                <div class="card shadow stat-card h-100" style="border-left: 4px solid #10b981;">
                  <div class="card-body d-flex align-items-center py-3 px-4">
                    <div class="mr-3"
                      style="width: 44px; height: 44px; background: #ecfdf5; border-radius: 10px; display: flex; align-items: center; justify-content: center; flex-shrink: 0;">
                      <i class="fe fe-users" style="font-size: 20px; color: #10b981;"></i>
                    </div>
                    <div>
                      <p class="mb-0 text-muted"
                        style="font-size: 0.75rem; text-transform: uppercase; letter-spacing: .05em;">Total Enrollees</p>
                      <h3 class="mb-0 font-weight-bold" style="line-height: 1.2;">
                        {{ clients.meta ? (clients.meta.total | numeral('0,0')) : '—' }}
                      </h3>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>

            <div class="col-lg-4 col-md-4 mb-3">
              <router-link to="/manage-clients" class="text-decoration-none">
                <div class="card shadow stat-card h-100" style="border-left: 4px solid #f59e0b;">
                  <div class="card-body d-flex align-items-center py-3 px-4">
                    <div class="mr-3"
                      style="width: 44px; height: 44px; background: #fffbeb; border-radius: 10px; display: flex; align-items: center; justify-content: center; flex-shrink: 0;">
                      <i class="fe fe-user-check" style="font-size: 20px; color: #f59e0b;"></i>
                    </div>
                    <div>
                      <p class="mb-0 text-muted"
                        style="font-size: 0.75rem; text-transform: uppercase; letter-spacing: .05em;">My Enrollees</p>
                      <h3 class="mb-0 font-weight-bold" style="line-height: 1.2;">
                        {{ enrollee_clients.meta ? (enrollee_clients.meta.total | numeral('0,0')) : '—' }}
                      </h3>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>

          <!-- ── Offline Sync Card ── -->
          <div class="card shadow-sm form-card mb-4">
            <div class="card-body px-4 py-3 d-flex flex-wrap align-items-center justify-content-between"
              style="gap: 10px;">
              <div class="d-flex align-items-center">
                <i class="fe fe-download-cloud text-primary mr-2" style="font-size: 1.1rem;"></i>
                <span class="font-weight-bold">Offline Facility Data</span>
              </div>
              <button type="button" class="btn btn-submit btn-sm" @click="fetchLga">
                <i class="fe fe-download-cloud mr-1"></i> Upload Facility Data to Offline
              </button>
            </div>

            <div class="card-body pt-0" v-show="show">
              <div class="form-row align-items-end">
                <div class="form-group col-md-6">
                  <label class="small font-weight-bold text-secondary">LGA</label>
                  <select class="form-control" v-model="selected_lga" @change="fetchFacilitiesperlga()">
                    <option v-for="lga in lga_states" v-bind:key="lga" :value="lga">{{ lga.local_name }}</option>
                  </select>
                </div>
                <div class="form-group col-md-6">
                  <button type="button" class="btn btn-submit" @click="saveData()">
                    <i class="fe fe-save mr-1"></i> Update Now
                  </button>
                </div>
              </div>
            </div>
          </div>

          <informallga />

          <!-- ── Enrollees Table ── -->
          <div class="card shadow table-card">
            <div class="d-flex align-items-center px-4 pt-4 pb-3">
              <i class="fe fe-users text-primary mr-2"></i>
              <h6 class="mb-0 font-weight-bold">Enrollees</h6>
            </div>
            <div class="table-responsive">
              <table class="table align-td-middle mb-0">
                <thead class="table-head">
                  <tr>
                    <th class="table-th px-4">Name</th>
                    <th class="table-th">Phone Number</th>
                    <th class="table-th">Sector</th>
                    <th class="table-th">RIVCHPP Number</th>
                    <th class="table-th"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="client in clients.data" v-bind:key="client.id" class="table-row">
                    <td class="px-4 py-3 font-weight-bold" style="font-size: 0.85rem;">
                      {{ client.firstname }} {{ client.lastname }}
                    </td>
                    <td class="py-3" style="font-size: 0.85rem;">{{ client.phone_number }}</td>
                    <td class="py-3" style="font-size: 0.85rem;">{{ client.sector }}</td>
                    <td class="py-3"><span class="code-chip">{{ client.id_card_number }}</span></td>
                    <td class="py-3">
                      <router-link :to="{ path: '/client/' + client.id }">
                        <button type="button" class="btn btn-outline-secondary btn-sm">
                          <i class="fe fe-eye"></i>
                        </button>
                      </router-link>
                    </td>
                  </tr>
                  <tr v-if="!clients.data || !clients.data.length">
                    <td colspan="5" class="text-center py-5 text-muted">
                      <i class="fe fe-users" style="font-size: 2rem; opacity: 0.3;"></i>
                      <p class="mt-2 mb-0">No enrollees found</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>

        <div class="vld-parent">
          <loading :active.sync="isLoading" loader="spinner" :can-cancel="false" :is-full-page="true"></loading>
        </div>
      </section>
    </main>
    <Footer />
  </div>

</template>

<script>
import Navbar from '@/views/Navbar.vue'
import TodayTasks from "@/components/TodayTasks.vue";
import Footer from '@/views/Footer.vue'
import informallga from '@/views/shis/components/informallga.vue'
// Import component
   import Loading from 'vue-loading-overlay';
   // Import stylesheet
   import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  components: { TodayTasks,
     Navbar, informallga, Footer, Loading
  },

  data(){
    return{
      auth_user:"",
      user:null,
      clients:"",
      enrollee_clients:"",
      selected_lga:"",
      facilities:"",
      wards:"",
      providers:"",
      isLoading: false,
      show: false,
      fullPage: true,
      lga_states: true,
    }
  },
  beforeMount(){
    this.axios.get(`/api/v1/auth/user`)
                .then(response => {
                    this.auth_user = response.data
                    console.log(response)
                })
                .catch(error => {
                    console.error(error);
                })
  },

  methods:{
    myEnrollees(){
      this.user = JSON.parse(localStorage.getItem('user'))
      this.axios.get(`/api/v1/auth/employee_client/${this.user.id}`)
                  .then(response => {
                      this.enrollee_clients = response.data
                      this.isLoading = false
                      console.log(response)
                  })
                  .catch(error => {
                      console.error(error);
                      this.isLoading = false

                  })

    },
    fetchFacilitiesperlga(){
      this.isLoading = true
      this.axios.get(`/api/v1/auth/getProviderPerLGA/${this.selected_lga.id}`)
                  .then(response => {
                      this.facilities = response.data.data
                      console.log(response)

                      //get wards
            this.axios.get(`/api/v1/auth/getwards/${this.selected_lga.id}`)
                        .then(response => {
                        this.wards = response.data.data

                            console.log(response)
                            this.isLoading = false

                        })
                        .catch(error => {
                            console.error(error);
                            this.isLoading = false

                        })
                      //end of get wards
                  })
                  .catch(error => {
                      console.error(error);
                      this.isLoading = false

                  })
    },
    fetchLga(){
      this.show = true
      this.axios.get(`/api/v1/auth/lga/2679`)
                  .then(response => {
                      this.lga_states = response.data.data
                      console.log(response)
                  })
                  .catch(error => {
                      console.error(error);
                  })
    },
    saveData(){
      this.isLoading = true
      localStorage.setItem('wards_data', JSON.stringify(this.wards));
      localStorage.setItem('facilities', JSON.stringify(this.facilities));
      localStorage.setItem('selected_lga', JSON.stringify(this.selected_lga))
      this.isLoading = false
      this.$toasted.info('Updated Successfully', {position: 'top-center', duration:3000 })



    },

    getClients(){
      this.user = JSON.parse(localStorage.getItem('user'))
      this.axios.get(`/api/v1/auth/getAgencyToUser/${this.user.institutional_id}`)
                  .then(response => {
                      this.clients = response.data
                      console.log(response)
                  })
                  .catch(error => {
                      console.error(error);
                  })
    },

    getProviders(){
      this.user = JSON.parse(localStorage.getItem('user'))
      this.axios.get(`/api/v1/auth/providerAgency/407465`)
                  .then(response => {
                      this.providers = response.data.data
                      console.log(response)
                  })
                  .catch(error => {
                      console.error(error);
                  })
    },



  },
  created(){
    this.getClients()
    this.getProviders()
    this.myEnrollees()

  }
}
</script>
<style lang="css" scoped>
  .stat-card {
    border-radius: 12px;
    transition: transform 0.15s, box-shadow 0.15s;
  }

  .stat-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1) !important;
  }
</style>
